<template>
  <div>
    <div id="welcome-back-page"></div>
    <transition-music></transition-music>
  </div>
</template>

<script>
export default {
  name: 'WelcomeBack',
  mounted() {
    import('./src/welcome-back-page-init').then((welcomeBackPage) => {
      this.$nextTick(() => {
        const game = welcomeBackPage.launch();
        window.addEventListener(
          'popstate',
          () => {
            game.destroy(true);
          },
          false,
        );
      });
    });
  },
};
</script>

<style lang="scss" scoped>
#welcome-back-page {
  display: flex;
  justify-content: center;
  height: 100vh;
}
</style>
